import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/lib/nav";

export function LandingNav() {
    const navigate = useNavigate();
    return (
        <nav className="sticky top-0 z-50 bg-obsidian/70 backdrop-blur-xl border-b border-white/10" data-testid="landing-nav">
            <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
                <button onClick={() => navigate("/")} className="flex items-center gap-2.5" data-testid="nav-logo">
                    <img src={LOGO_URL} alt="WhiteWater AI" className="w-9 h-9" />
                    <span className="font-heading font-extrabold tracking-tight text-white text-lg">WhiteWater<span className="text-volt">AI</span></span>
                </button>
                <div className="flex items-center gap-2 sm:gap-3">
                    <button onClick={() => navigate("/login")} data-testid="nav-login-button"
                        className="h-10 px-4 sm:px-5 text-sm font-semibold text-white/80 hover:text-white border border-white/15 hover:border-white/40 rounded-sm transition-colors">
                        Log In
                    </button>
                    <button onClick={() => navigate("/register")} data-testid="nav-cta-button"
                        className="h-10 px-4 sm:px-5 text-sm font-bold uppercase tracking-wide bg-volt text-black rounded-sm hover:bg-[#33ceff] transition-colors">
                        Start Free Trial
                    </button>
                </div>
            </div>
        </nav>
    );
}
